import Api from ".";
import { DEVURL } from "./envUrl";

export const getAllFilesDetails = async (projectId,payLoad, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/getAllFileDetails/${projectId}`;
  const addResponse = await axiosInstance({
    url: apiURL,
    method: "POST",
    data:payLoad
  });
  return {
    response: addResponse?.data?.FileDetails,
    specialProjectFlag: addResponse?.data?.SpecialProject,
    AccessType:addResponse?.data?.AccessType,
  };
};

export const deleteFileGroup = async (projectId, taskId, fileGroup, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/deleteFileMetaData/${projectId}/${taskId}/${fileGroup}`;
  const deleteResponse = await axiosInstance({
    url: apiURL,
    method: "DELETE",
  });
  return deleteResponse?.data;
};

export const uploadAdditionalFilesMetadata = async (fileMetadata, projectID, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });

  // Construct the API endpoint
  const apiURL = `${DEVURL}/uploadAdditionalFiles/${projectID}`;

  // Build the payload with ArtworkAgilityPage structure
  const payload = {
    ArtworkAgilityPage: {
      AdditionalFilesList: fileMetadata.AdditionalFilesList,
    },
  };

  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error uploading additional files metadata:", error);
    throw error;
  }
};

export const buildFileMetadata = (fileItem, sequence, AWMProjectID) => {
  const fileName = fileItem?.File_Name || fileItem?.name || "unknown";
  const fileSize = fileItem?.size || 1;

  // Extract file type from file name or use generic type
  const fileExtension = fileName.split(".").pop().toLowerCase();

  return {
    GroupName: "Additional Files Uploaded",
    Size: fileSize.toString(),
    Sequence: sequence.toString(),
    Filename: fileName,
    Full_Name: fileItem?.Full_Name || "",
    Email: fileItem?.Email || "",
    TypeOfFile: fileExtension,
    AWMProjectID: AWMProjectID,
    Version: 1,
    Action: "add",
    ReadOnlyURL: "",
    Filepath: "",
  };
};